/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit ChoiceRadial/view.blocks to change it.
import "DesignSystem/Fonts/Inter-400.css"
import "DesignSystem/Fonts/Inter-500.css"
import React from 'react'
import styles from './view.module.css'
import useIsHovered from 'Simple/hooks/useIsHovered'



/** @type {import('Simple/types.js').View} */
export default function ChoiceRadial({
  children,
  viewPath = "/DesignSystem/ChoiceRadial",
  backgroundColor = "#ffffff",
  borderBottomLeftRadius = 6,
  borderBottomRightRadius = 6,
  borderColor = "#ebebeb",
  borderStyle = "solid",
  borderTopLeftRadius = 6,
  borderTopRightRadius = 6,
  borderWidth = 1,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  marginTop = 0,
  onClick,
  paddingBottom = 30,
  paddingLeft = 15,
  paddingRight = 15,
  paddingTop = 30,
  width = 100,
  isSelected,
  alignSelf = "center",
  color = "#404040",
  fontSize = 20,
  fontWeight = 500,
  text = "Medicare"
  
}) {
let [isHovered, isSelectedHovered, isHoveredBind] = useIsHovered({isSelected})
  return (<React.Fragment
>
<button
  data-testid="ChoiceRadial.ChoiceRadial:1"
  data-view-path={viewPath}
 {...isHoveredBind}
 onClick={onClick}
 style={{'--bblr-2-ZLDt9k': typeof borderBottomLeftRadius === 'number' ? `${borderBottomLeftRadius}px` : borderBottomLeftRadius,'--bbrr-3-ZLDt9k': typeof borderBottomRightRadius === 'number' ? `${borderBottomRightRadius}px` : borderBottomRightRadius,'--bs-5-ZLDt9k': borderStyle,'--btlr-6-ZLDt9k': typeof borderTopLeftRadius === 'number' ? `${borderTopLeftRadius}px` : borderTopLeftRadius,'--btrr-7-ZLDt9k': typeof borderTopRightRadius === 'number' ? `${borderTopRightRadius}px` : borderTopRightRadius,'--bw-8-ZLDt9k': typeof borderWidth === 'number' ? `${borderWidth}px` : borderWidth,'--mb-9-ZLDt9k': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-10-ZLDt9k': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-11-ZLDt9k': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--mt-12-ZLDt9k': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--pb-13-ZLDt9k': typeof paddingBottom === 'number' ? `${paddingBottom}px` : paddingBottom,'--pl-14-ZLDt9k': typeof paddingLeft === 'number' ? `${paddingLeft}px` : paddingLeft,'--pr-15-ZLDt9k': typeof paddingRight === 'number' ? `${paddingRight}px` : paddingRight,'--pt-16-ZLDt9k': typeof paddingTop === 'number' ? `${paddingTop}px` : paddingTop,'--w-17-ZLDt9k': typeof width === 'number' ? `${width}px` : width,'--bc-1-ZLDt9k': isSelected ? "rgba(0, 234, 141, 0.05)" : isHovered ? "rgba(0, 234, 141, 0.05)" : backgroundColor,'--bc-4-ZLDt9k': isSelected ? "rgba(0, 188, 112, 0.83)" : isHovered ? "rgba(0, 188, 112, 0.83)" : borderColor}}
 className={`views-block ${styles.ChoiceRadial1}`}
>
<span
  data-testid="ChoiceRadial.Text"
  data-view-path={viewPath}
 style={{'--as-18-ZLDt9k': alignSelf,'--fs-20-ZLDt9k': typeof fontSize === 'number' ? `${fontSize}px` : fontSize,'--fw-21-ZLDt9k': fontWeight,'--c-19-ZLDt9k': isHovered ? "rgba(0, 188, 112, 0.83)" : color}}
 className={`views-text ${styles.Text}`}
>
{text}
</span>
</button>
{children}
</React.Fragment>)
}